import { useMemo, useState } from 'react';

import { SecurityCheckIcon, UserIcon, UserMultipleIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useDocumentTitle } from 'hooks/document-title';
import { useLocale } from 'hooks/locale';
import AppPage from 'layouts/AppPage/AppPage';
import { Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { OverflowTabs } from 'components/Tabs/Tabs';

import { selectCompanyChecks } from 'api/company-checks-slice';
import { selectCompany } from 'api/company-slice';
import { selectUser } from 'api/user-slice';

import { CandidatesReporting } from './tabs/CandidatesReporting/CandidatesReporting';
import { ChecksReporting } from './tabs/ChecksReporting/ChecksReporting';
import { RefereesReporting } from './tabs/RefereesReporting/RefereesReporting';

const Reporting = () => {
  useDocumentTitle('Reporting');

  const companyChecks = useSelector(selectCompanyChecks);
  const company = useSelector(selectCompany);
  const user = useSelector(selectUser);

  const locale = useLocale(company?.locale);

  const [loading, setLoading] = useState(false);

  const hasReference = useMemo(() => {
    if (!Array.isArray(companyChecks)) return false;

    return companyChecks.some(cc => ['reference', 'custom_reference'].includes(cc.type));
  }, [companyChecks]);

  return (
    <AppPage loading={loading}>
      <AppPage.Header
        title="Reporting"
        subtitle="Analyse your company data, draw insights and export reports."
      />
      <OverflowTabs
        defaultActiveKey="checks"
        className="mt-12 mx-12"
        mountOnEnter={true}
        unmountOnExit={true}>
        <Tab
          eventKey="checks"
          title={
            <span className="flex items-center gap-2">
              <HugeiconsIcon icon={SecurityCheckIcon} size="16" strokeWidth={2} /> Checks
            </span>
          }>
          <ChecksReporting
            setLoading={setLoading}
            locale={locale}
            companyChecks={companyChecks}
            user={user}
          />
        </Tab>
        <Tab
          eventKey="candidates"
          title={
            <span className="flex items-center gap-2">
              <HugeiconsIcon icon={UserIcon} size="16" strokeWidth={2} /> Candidates
            </span>
          }>
          <CandidatesReporting setLoading={setLoading} locale={locale} user={user} />
        </Tab>
        {hasReference && (
          <Tab
            eventKey="referees"
            title={
              <span className="flex items-center gap-2">
                <HugeiconsIcon icon={UserMultipleIcon} size="16" strokeWidth={2} /> Referees
              </span>
            }>
            <RefereesReporting setLoading={setLoading} locale={locale} user={user} />
          </Tab>
        )}
      </OverflowTabs>
    </AppPage>
  );
};

export default Reporting;
